/*
  LUXBMX forms. Any <form data-lux-form="<id>"> posts its answers to HUB
  through the app proxy (/apps/wishlist/forms/<id>), which saves them and opens
  a Gorgias ticket. Photos are shrunk in the browser first (longest side
  1600px, JPEG) so four phone photos fit in one request.
*/
(function () {
  'use strict';

  var MAX_SIDE = 1600;
  var QUALITY = 0.8;

  function decode(file) {
    if (window.createImageBitmap) {
      return createImageBitmap(file).catch(function () { return viaImg(file); });
    }
    return viaImg(file);
  }

  function viaImg(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { resolve(img); };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
      img.src = url;
    });
  }

  function shrink(file) {
    return decode(file).then(function (img) {
      var w = img.width, h = img.height;
      var scale = Math.min(1, MAX_SIDE / Math.max(w, h));
      var canvas = document.createElement('canvas');
      canvas.width = Math.round(w * scale);
      canvas.height = Math.round(h * scale);
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      return { name: file.name, type: 'image/jpeg', data: canvas.toDataURL('image/jpeg', QUALITY) };
    });
  }

  function setStatus(form, text, isError) {
    var el = form.querySelector('[data-lux-form-status]');
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('is-error', !!isError);
  }

  function listFiles(input, list) {
    if (!list) return;
    list.textContent = '';
    Array.prototype.forEach.call(input.files || [], function (f) {
      var li = document.createElement('li');
      li.textContent = f.name;
      list.appendChild(li);
    });
  }

  function prefill(form) {
    var params = new URLSearchParams(window.location.search);
    form.querySelectorAll('[data-query]').forEach(function (el) {
      var v = params.get(el.getAttribute('data-query'));
      if (v && !el.value) el.value = v;
    });
    form.querySelectorAll('select[data-default]').forEach(function (el) {
      if (!el.value || el.selectedIndex === 0) el.value = el.getAttribute('data-default');
    });
  }

  function init(form) {
    var started = Date.now();
    prefill(form);
    var id = form.getAttribute('data-lux-form');
    var button = form.querySelector('[type="submit"]');
    var fileInput = form.querySelector('input[type="file"]');
    var max = fileInput ? parseInt(fileInput.getAttribute('data-max') || '4', 10) : 0;

    if (fileInput) {
      var list = form.querySelector('[data-lux-form-files]');
      fileInput.addEventListener('change', function () {
        if (fileInput.files.length > max) {
          setStatus(form, 'Up to ' + max + ' photos, please.', true);
          fileInput.value = '';
        } else {
          setStatus(form, '');
        }
        listFiles(fileInput, list);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;
      var emptyGroup = Array.prototype.find.call(form.querySelectorAll('[data-required-group]'), function (g) {
        return !g.querySelector('input:checked');
      });
      if (emptyGroup) {
        setStatus(form, emptyGroup.getAttribute('data-required-group'), true);
        return;
      }

      var fields = {};
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name || el.type === 'file' || el.name === 'hp') return;
        if (el.type === 'checkbox' && el.hasAttribute('data-multi')) {
          if (!fields[el.name]) fields[el.name] = [];
          if (el.checked) fields[el.name].push(el.value);
        } else if (el.type === 'checkbox') fields[el.name] = el.checked;
        else if (el.type === 'radio') { if (el.checked) fields[el.name] = el.value; }
        else fields[el.name] = el.value;
      });
      var hp = form.elements.hp ? form.elements.hp.value : '';

      button.disabled = true;
      setStatus(form, fileInput && fileInput.files.length ? 'Preparing your photos...' : 'Sending...');

      var files = fileInput ? Array.prototype.slice.call(fileInput.files, 0, max) : [];
      Promise.all(files.map(shrink))
        .catch(function () {
          throw new Error('One of the photos could not be read. Please use a JPG or PNG photo.');
        })
        .then(function (photos) {
          setStatus(form, 'Sending...');
          return fetch('/apps/wishlist/forms/' + encodeURIComponent(id), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ fields: fields, files: photos, hp: hp, ms: Date.now() - started })
          });
        })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (body) {
            if (!res.ok || !body.ok) {
              throw new Error(body.error || 'That did not go through. Please try again, or email help@luxbmx.com.');
            }
          });
        })
        .then(function () {
          var done = form.parentNode.querySelector('[data-lux-form-done]');
          form.dispatchEvent(new CustomEvent('lux-form:sent', { bubbles: true }));
          form.hidden = true;
          if (done) {
            done.hidden = false;
            done.setAttribute('tabindex', '-1');
            done.focus();
          }
        })
        .catch(function (err) {
          button.disabled = false;
          setStatus(form, err.message, true);
        });
    });
  }

  function boot() {
    document.querySelectorAll('form[data-lux-form]').forEach(function (form) {
      if (form.hasAttribute('data-lux-form-ready')) return;
      form.setAttribute('data-lux-form-ready', '');
      init(form);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
